import { render } from "./ImageRotator.vue?vue&type=template&id=5d8a6684&scoped=true"
import script from "./ImageRotator.vue?vue&type=script&lang=js"
export * from "./ImageRotator.vue?vue&type=script&lang=js"

import "./ImageRotator.vue?vue&type=style&index=0&id=5d8a6684&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8a6684"]])

export default __exports__